<template>
    <div class="tip1_module trans">
        <div class="tip1_module_title_1">推荐好医生</div>
        <div class="tip1_module_content_1">若当前咨询的医生未回复，平台会根据您的情况为你推荐另一位好评医生。推荐不需要支付额外费用。</div>
        <div class="tip1_module_btn_1" @click="showFillModule">好的</div>

    </div>
</template>
<script>
export default {
    methods:{
        showFillModule(){
            this.$emit("showFillModule")
        }
    }
}
</script>
<style lang="scss" scoped>
.tip1_module{
    position: absolute;
    background-color: #fff;
    text-align: center;
    width: 300px;
    height: 270px;
    border-radius: 10px;
    padding: 30px 20px;
    .tip1_module_title_1{
        font-weight: bold;
        font-size: 20px;
    }
    .tip1_module_content_1{
        margin: 30px 0 40px 0;
        font-size: 16px;
    }
    .tip1_module_btn_1{
        width: 80px;
        height: 40px;
        line-height: 40px;
        margin: 0 auto;
        background-color: #2f318b;
        color: #fff;
        border-radius: 8px;
        cursor: pointer;
    }

}
</style>